<div class="linked-select">
  <div class="link-wrapper">
    <a
      class="link"
      ixTest="manage-certificates"
      [routerLink]="['/', 'credentials', 'certificates']"
    >
      {{ 'Manage Certificates' | translate }}
    </a>
  </div>
  <ng-content></ng-content>
</div>
